import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const adminAxios = axios.create({ baseURL: BASE });

adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth
export const adminLogin = (data) => adminAxios.post('/auth/login', data);

// Stats
export const getAdminStats = () => adminAxios.get('/admin/stats');

// Users
export const getAdminUsers = (params) => adminAxios.get('/admin/users', { params });
export const getAdminUserById = (id) => adminAxios.get(`/admin/users/${id}`);
export const toggleUserStatus = (id) => adminAxios.patch(`/admin/users/${id}/status`);
export const creditUserWallet = (id, data) => adminAxios.post(`/admin/users/${id}/credit`, data);
export const debitUserWallet = (id, data) => adminAxios.post(`/admin/users/${id}/debit`, data);

// Plans
export const getAdminPlans = () => adminAxios.get('/admin/plans');
export const createAdminPlan = (data) => adminAxios.post('/admin/plans', data);
export const updateAdminPlan = (id, data) => adminAxios.put(`/admin/plans/${id}`, data);
export const deleteAdminPlan = (id) => adminAxios.delete(`/admin/plans/${id}`);

// Withdrawals
export const getAdminWithdrawals = (params) => adminAxios.get('/admin/withdrawals', { params });
export const approveWithdrawal = (id) => adminAxios.patch(`/admin/withdrawals/${id}/approve`);
export const rejectWithdrawal = (id, data) => adminAxios.patch(`/admin/withdrawals/${id}/reject`, data);

// Transactions
export const getAdminTransactions = (params) => adminAxios.get('/admin/transactions', { params });

// Payments (Deposit Intents)
export const getAdminPayments = (params) => adminAxios.get('/admin/payments', { params });

// Fees History
export const getAdminFees = (params) => adminAxios.get('/admin/fees', { params });

// Profile Update Requests
export const getAdminProfileUpdateRequests = (params) => adminAxios.get('/admin/profile-update-requests', { params });
export const getAdminProfileUpdateRequest = (id) => adminAxios.get(`/admin/profile-update-requests/${id}`);
export const approveProfileUpdateRequest = (id, data) => adminAxios.patch(`/admin/profile-update-requests/${id}/approve`, data);
export const rejectProfileUpdateRequest = (id, data) => adminAxios.patch(`/admin/profile-update-requests/${id}/reject`, data);

// Commission jobs
export const getAdminCommissionJobs = (params) => adminAxios.get('/admin/commission-jobs', { params });

export const updateAdminUserProfile = (id, data) => adminAxios.patch(`/admin/users/${id}/profile`, data);
export const getAdminUserSlotUpgrades = (params) => adminAxios.get('/admin/user-slot-upgrades', { params });
export const getAdminCommissionPayouts = (params) => adminAxios.get('/admin/commission-payouts', { params });

// Impersonation
export const impersonateUser = (id) => adminAxios.post(`/admin/users/${id}/impersonate`);

// System Config
export const getAdminSystemConfigs = () => adminAxios.get('/admin/system-configs');
export const createAdminSystemConfig = (data) => adminAxios.post('/admin/system-configs', data);
export const updateAdminSystemConfig = (id, data) => adminAxios.put(`/admin/system-configs/${id}`, data);
